import formatTable, { Column } from './format-table'

export type StrippedStorePart = {
	part?: {
		provider: {
			name: string,
		},
		partClass: {
			description: string,
		},
		partNumber?: string | null,
	} | null,
	quantityReceived?: number | null,
	quantityOrdered: number,
	costPerItem: number,
}

export const columns: Column<StrippedStorePart>[] = [
	{
		label: 'Manufacturer',
		buildString: ( row: StrippedStorePart ) => row?.part?.provider.name ?? '',
	},
	{
		label: 'Item',
		buildString: ( row: StrippedStorePart ) => row?.part?.partClass.description ?? '',
	},
	{
		label: '#',
		buildString: ( row: StrippedStorePart ) => row?.part?.partNumber ?? '',
	},
	{
		label: 'Qty',
		buildString: ( row: StrippedStorePart ) => ( row.quantityReceived && Number.isInteger( row.quantityReceived ) ? row.quantityReceived : row.quantityOrdered ).toString(),
		align: 'right',
	},
	{
		label: 'Cost (per unit)',
		buildString: ( row: StrippedStorePart ) => `$${( row?.costPerItem ?? 0 ).toFixed( 2 )}`,
		align: 'right',
	},
]

export default function buildPartsText( items: StrippedStorePart[] ) {
	return formatTable( columns, items )
}
